// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from './content';
import { _ } from "~/i18n";

export default class Price extends Content {
	_build() {
		/* vyuziva CSS classy admission, protoze ji nahrazuje */
		this._dom.container.classList.add("content-admission");
		var today = parseInt(new Date().format("nd"));

		var currencies = {
			CZK: "Kč",
			USD: "$",
			EUR: "€"
		};

		var data = {
			parking: [],
			admission: []
		};

		/* sgrupovat data podle typu */
		for (var i = 0; i < this._data.length; i++) {
			switch (this._data[i].type) {
				case "parking":
					data.parking.push(this._data[i]);
				break;
				default:
					data.admission.push(this._data[i]);
				break;
			}
		}

		for (let section in data) {
			var str = "";
			/* najit nadpis */
			for (var i = 0; i < data[section].length; i++) {
				var row = data[section][i];
				if (this._matches(row, today)) {
					this._dom.container.appendChild(node("h3", { innerHTML: this._formatTitle(row) }));
					break;
				}
			}

			/* vypsat vstupy */
			var str = "<table>";
			for (var i = 0; i < data[section].length; i++) {
				var row = data[section][i];
				if (!this._matches(row, today)) { continue; }

				str += "<tr><td>" + row.label + '</td><td class="last">';
				str += " " + row.amount + " " + (currencies[row.currency] || row.currency) + "</td></tr>";
			}
			str += "</table>";

			this._dom.container.insertAdjacentHTML("beforeend", str);
		}
	}

	_matches(row, today) {
		if (!row.start && !row.end) { return true; }
		return (today >= row.start && today <= row.end);
	}

	_formatTitle(row) {
		var result = (row.type ==  "parking" ? _("detail.content.price.price") : _("detail.content.price.admission"));
		if (row.start && row.end) {
			result += " (" + this._formatDay(row.start) + " &ndash; " + this._formatDay(row.end) + ")";
		}
		return result;
	}

	_formatDay(num) {
		var day = num % 100;
		var month = Math.floor(num/100)-1;
		return day + ". " + _("detail.content.smallMonth.genetiv." + month);
	}
}
